export default "__VITE_ASSET__iivt_XSC__"